import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* ── PWA Service Worker ── */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then(reg => {
        /* Check for updates every 60 seconds */
        setInterval(() => reg.update(), 60000);

        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
              /* New version available — show update banner */
              showUpdateBanner(newSW);
            }
          });
        });
      })
      .catch(err => console.warn('SW registration failed:', err));

    /* Reload page after SW takes control (after update) */
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) { refreshing = true; window.location.reload(); }
    });
  });
}

function showUpdateBanner(newSW) {
  const banner = document.createElement('div');
  banner.id = 'pwa-update-banner';
  banner.innerHTML = `
    <span>New version available!</span>
    <button onclick="this.parentElement.remove(); arguments[0].target.dispatchEvent(new Event('click'))">Update Now</button>
  `;
  banner.style.cssText = `
    position:fixed; bottom:50px; left:50%; transform:translateX(-50%);
    background:#c8102e; color:#fff; padding:10px 20px; border-radius:8px;
    display:flex; align-items:center; gap:16px; z-index:99999;
    font-family:sans-serif; font-size:14px; box-shadow:0 4px 20px rgba(0,0,0,0.4);
    white-space:nowrap;
  `;
  const btn = banner.querySelector('button');
  btn.style.cssText = `
    background:rgba(255,255,255,0.25); border:1px solid rgba(255,255,255,0.5);
    color:#fff; padding:5px 14px; border-radius:4px; cursor:pointer; font-size:13px;
  `;
  btn.addEventListener('click', () => {
    newSW.postMessage('SKIP_WAITING');
    banner.remove();
  });
  document.body.appendChild(banner);
}
